import React from 'react'

import moment from 'moment'
import _ from 'underscore'

import ParcelActions from '../../actions/ParcelActions.js'
import AddressActions from '../../actions/AddressActions.js'

import {Alert, SplitButton, IconButton, Popup, Modal, ModalHeader, ModalActions, H6} from '../UI/index.js'
import Address from '../addresses/Address.js'
import CarrierSelector from './CarrierSelector.js'
import NewParcel from '../../../server/functions/parcels/NewParcel.js'
import {formSpacing, Check, FormRow, FormStack, Input, Select, MetricInput} from '../UI/forms/index.js'
import ParcelCustoms from './ParcelCustoms.js'
import ParcelOptions from './ParcelOptions.js'
import time from '../../../server/utils/time.js'
import OCR from './OCRModal.js'
import {outsideEUCustoms} from 'utils/EU.js'
import t from '../../helpers/Languages.js'

class EditParcelModal extends React.Component {
    constructor(props) {
        super(props)

        this.initialState = {
            modalIsOpen: false,
            useOCR: false,
            ocrLoading: false,
            rememberCustomer: false,
            createParcelMode: localStorage.createParcelMode || 'save',
            parcel: NewParcel(),
            customer: {settings: {parcels: {defaultOptions: []}}},
            parcelCarriers: [],
            options: [],
            disabledOptions: [],
            amounts: [],
            deliveryTimes: [],
            pickupDates: [],
            pickupPoints: [],
            optionsHaveChanged: false,
            sizeOption: props.user?.settings?.parcels?.sizes?.findIndex((size) => size.isDefault) ?? undefined,
            validation: {},
            loading: false,
            info: '',
            warning: '',
            error: ''
        }

        this.state = JSON.parse(JSON.stringify(this.initialState))
    }

    open(parcel, callback) {
        const {reseller, user, customers} = this.props

        let customer
        let sizeOption

        parcel = parcel ? JSON.parse(JSON.stringify(parcel)) : NewParcel()

        if (user.isCustomer) {
            customer = JSON.parse(JSON.stringify(user))

            const sizes = user.settings?.parcels?.sizes || []

            if (parcel._id) {
                const index = sizes.findIndex((size) => size.width === parcel.width && size.length === parcel.length && size.height === parcel.height)

                if (index > -1) {
                    sizeOption = index
                }
            } else {
                const index = sizes.findIndex((size) => size.isDefault)

                if (index > -1) {
                    parcel.length = sizes[index].length
                    parcel.width = sizes[index].width
                    parcel.height = sizes[index].height
                    sizeOption = index
                }
            }
        } else {
            if (parcel._id) {
                customer = customers[parcel.customer] || this.state.customer
            } else {
                customer = this.state.customer
            }
        }

        if (reseller.isShop && customers && _.keys(customers).length === 1) {
            customer = JSON.parse(JSON.stringify(_.values(customers)[0]))
        }

        if (!parcel._id && customer._id) {
            parcel.customer = customer._id
            parcel.comment = customer.settings.parcels.defaultComment || ''
        }

        const createParcelMode = localStorage.createParcelMode || 'save'

        console.log(parcel)

        this.setState({modalIsOpen: true, parcel, customer, createParcelMode, sizeOption, callback}, () => {
            this.getOptions(true)

            if (user.isCustomer || (reseller.isShop && customer._id)) {
                setTimeout(() => this.parcelAddress.focus(), 10)
            } else {
                setTimeout(() => this.selectCustomer.focus(), 10)
            }
        })
    }

    close() {
        this.setState(JSON.parse(JSON.stringify(this.initialState)))
    }

    onChangeCustomer(event) {
        const {customers} = this.props
        const parcel = {...this.state.parcel}

        const customer = customers[event.target.value]

        if (customer) {
            parcel.customer = customer._id
            parcel.contact = ''
            parcel.options = []

            // The server picks the sender address of the new customer
            parcel.senderAddress = NewParcel().senderAddress
            parcel.emailTT = customer.settings.parcels.emailTT || ''

            this.setState({parcel, customer}, () => {
                this.getOptions()
                setTimeout(() => this.parcelAddress.focus(), 10)
            })
        }
    }

    onChangeContact(event) {
        const {customer} = this.state
        const parcel = {...this.state.parcel}

        parcel.contact = event.target.value

        const contact = _.find(customer?.contacts, {name: parcel.contact})

        if (contact) {
            parcel.emailTT = contact.emailTT || parcel.emailTT
        }

        this.setState({parcel})
    }

    onChangePickupAddress(address) {
        const parcel = {...this.state.parcel}

        // Only NL is allowed for pickups
        address.country = 'NL'

        parcel.pickupAddress = address

        this.setState({parcel})
    }

    onChangeAddress(address) {
        const parcel = {...this.state.parcel}

        const countryChanged = parcel.address.country !== address.country

        if (countryChanged) {
            parcel.options = []
        }

        if (countryChanged || outsideEUCustoms(parcel.address) !== outsideEUCustoms(address)) {
            if (outsideEUCustoms(address) || address.country === 'IE') {
                if (!parcel.customs) {
                    parcel.customs = {
                        typeItem: 'Commercial Goods',
                        typeNumber: 'invoice',
                        number: '',
                        currency: 'EUR',
                        content: [{
                            description: '',
                            quantity: 1,
                            weight: 0,
                            value: '0,00',
                            hsCode: '',
                            countryOrigin: 'NL'
                        }]
                    }
                }
            } else {
                delete parcel.customs
            }
        }

        // The selected pickup point belongs to the old address, let the backend select a new one
        const locationFields = ['street', 'nr', 'postalCode', 'city', 'country']
        if (parcel.pickupPoint && locationFields.some((field) => parcel.address[field] !== address[field])) {
            delete parcel.pickupPoint
            delete parcel.carrier
        }

        parcel.address = address

        if (address.instructions) {
            parcel.comment = address.instructions
        }

        this.setState({parcel, optionsHaveChanged: false}, () => {
            this.getOptions()
        })
    }

    onChangeParcelCustoms(parcel) {
        let weight = 0

        parcel.customs.content.map((content) => {
            weight += content.weight
        })

        // The customs type limits the available carriers, e.g. PostNL does not support Gift
        const typeItemChanged = parcel.customs.typeItem !== this.customsTypeItem
        this.customsTypeItem = parcel.customs.typeItem

        if (weight !== parcel.weight) {
            parcel.weight = weight
            parcel.options = []

            this.setState({parcel}, () => {
                this.getOptions()
            })
        } else if (typeItemChanged) {
            // Keep the selected carrier when it is still available
            this.setState({parcel}, () => {
                this.getOptions(true)
            })
        } else {
            this.setState({parcel})
        }
    }

    onChangeWeight(event) {
        const parcel = {...this.state.parcel}
        parcel.weight = parseInt(event.target.value) || 0
        parcel.options = []

        this.setState({parcel}, () => {
            this.getOptions()
        })
    }

    onChangeParcelSize(event) {
        const parcel = {...this.state.parcel}
        const {user} = this.props

        const size = user.settings.parcels.sizes[event.target.value]

        parcel.length = size.length
        parcel.width = size.width
        parcel.height = size.height

        this.setState({
            parcel,
            sizeOption: +event.target.value
        }, () => {
            this.getOptions()
        })
    }

    onChangeValue(key, event) {
        const {user} = this.props
        const {parcel, pickupPoints, infoMessages} = this.state

        if (key === 'length' || key === 'width' || key === 'height') {
            parcel[key] = +event.target.value

            if (user.isCustomer) {
                const sizes = user.settings.parcels?.sizes || []
                const index = sizes.findIndex((size) => size.width === parcel.width && size.length === parcel.length && size.height === parcel.height)
                this.setState({
                    sizeOption: index > -1 ? index : undefined
                }, () => {
                    this.getOptions()
                })
            } else {
                this.getOptions()
            }
        } else if (key === 'carrier') {
            const carrier = event.target.value
            const firstPickupPoint = pickupPoints.find((point) => point.carrier === carrier)
            parcel.pickupPoint = firstPickupPoint
            parcel[key] = event.target.value
            const info = infoMessages.find((message) => message.carrier === carrier)
            this.setState({parcel, info: info?.message})
        } else {
            parcel[key] = event.target.value
            this.setState({parcel})
        }
    }

    onChangeFee(key, index, event) {
        const {reseller} = this.props
        const parcel = {...this.state.parcel}

        if (key === 'id') {
            const selectedFee = _.findWhere(reseller.settings.parcels.fees, {id: event.target.value})

            if (selectedFee && selectedFee.id) {
                const fee = JSON.parse(JSON.stringify(selectedFee))
                fee.quantity = 1

                if (fee.basedOn && fee.basedOn !== 'fixedPrice') {
                    fee.percentage = fee.price
                }

                parcel.fees[index] = fee
            }

            if (!event.target.value) {
                parcel.fees.splice(index, 1)
            }

            if (index === parcel.fees.length) {
                const selectedFee = _.findWhere(reseller.settings.parcels.fees, {id: event.target.value})

                if (selectedFee && selectedFee.id) {
                    const fee = JSON.parse(JSON.stringify(selectedFee))
                    fee.quantity = 1

                    if (fee.basedOn && fee.basedOn !== 'fixedPrice') {
                        fee.percentage = fee.price
                    }

                    parcel.fees.push(fee)
                    this.setState({parcel})
                }
            }
        }

        if (key === 'quantity') {
            if (/^[0-9]{0,5}$/.test(event.target.value)) {
                parcel.fees[index].quantity = parseInt(event.target.value) || 0
            }
        }

        this.setState({parcel})
    }

    onChangeCover(event) {
        const parcel = {...this.state.parcel}

        parcel.cover = parseInt(event.target.value)

        this.setState({parcel}, () => {
            this.getOptions()
        })
    }

    onChangeDeliveryTime(event) {
        const parcel = {...this.state.parcel}
        parcel.deliveryTime = event.target.value

        this.setState({parcel}, () => {
            this.getOptions()
        })
    }

    onChangePickupPoint(event) {
        const {pickupPoints} = this.state
        const parcel = {...this.state.parcel}

        parcel.pickupPoint = _.findWhere(pickupPoints, {description: event.target.value})

        parcel.carrier = parcel.pickupPoint.carrier

        this.setState({parcel})
    }

    onChangeOptions(options) {
        const parcel = {...this.state.parcel}

        parcel.options = options

        delete parcel.cover
        delete parcel.deliveryTime
        delete parcel.pickupDate

        if (parcel.options.indexOf('Pick & Ship') > -1) {
            parcel.pickupAddress = parcel.pickupAddress || {
                name: '',
                attention: '',
                street: '',
                nr: '',
                addition: '',
                street2: '',
                postalCode: '',
                city: '',
                country: 'NL',
                email: '',
                phone: ''
            }
        } else {
            delete parcel.pickupAddress
        }

        this.setState({parcel, optionsHaveChanged: true}, () => {
            if (parcel.options.includes('Px')) {
                document.getElementById('pxBarcode')?.focus()
            }

            this.getOptions()
        })
    }

    getOptions(edit) {
        const parcel = {...this.state.parcel}

        if (parcel.address.postalCode && (parcel.address.country !== 'NL' || parcel.address.nr) && parcel.address.city && parcel.address.street) {
            ParcelActions.getOptions(parcel, (err, response) => {
                if (!err) {
                    const {options, disabledOptions, parcelCarriers, prices, amounts, deliveryTimes, pickupDates, pickupPoints, infoMessages = []} = response
                    const {customer, optionsHaveChanged} = this.state
                    const parcel = {...this.state.parcel} // Reassign parcel to get latest state

                    parcel.carrier = edit && parcelCarriers.indexOf(parcel.carrier) > -1 ? parcel.carrier : (parcelCarriers[0] || '')
                    parcel.options = response.parcel.options

                    if (response.parcel.cover) {
                        parcel.cover = response.parcel.cover
                    } else {
                        delete parcel.cover
                    }

                    if (response.parcel.deliveryTime) {
                        parcel.deliveryTime = response.parcel.deliveryTime
                    } else {
                        delete parcel.deliveryTime
                    }

                    if (response.parcel.pickupDate) {
                        parcel.pickupDate = response.parcel.pickupDate
                    } else {
                        delete parcel.pickupDate
                    }

                    if (response.parcel.pickupPoint) {
                        parcel.pickupPoint = response.parcel.pickupPoint
                        parcel.carrier = response.parcel.pickupPoint.carrier
                    } else {
                        delete parcel.pickupPoint
                    }

                    if (!parcel._id && !optionsHaveChanged) {
                        const enabledOptions = _.difference(options, disabledOptions)
                        let defaultOptions = _.difference(customer.settings.parcels.defaultOptions, parcel.options)

                        if (customer.settings.parcels.autoSameDayNextDay) {
                            const index = parcel.options.indexOf('Same Day')

                            if (index === -1 && time.time() <= customer.settings.parcels.sameDayCuttoff || time.time() > customer.settings.parcels.nextDayCuttoff) {
                                defaultOptions.push('Same Day')
                            }
                        }

                        // TODO: remove this after Px pilot
                        if (parcel.address.px && enabledOptions.includes('Px') && !parcel.options.includes('Px')) {
                            parcel.options.push('Px')

                            setTimeout(() => {
                                document.getElementById('pxBarcode')?.focus()
                            }, 100)
                        }

                        defaultOptions = _.intersection(defaultOptions, enabledOptions)

                        if (defaultOptions[0]) {
                            parcel.options.push(defaultOptions[0])

                            if (parcel.options.indexOf('Pick & Ship') > -1) {
                                parcel.pickupAddress = parcel.pickupAddress || {
                                    name: '',
                                    attention: '',
                                    street: '',
                                    nr: '',
                                    addition: '',
                                    street2: '',
                                    postalCode: '',
                                    city: '',
                                    country: 'NL',
                                    email: '',
                                    phone: ''
                                }
                            } else {
                                delete parcel.pickupAddress
                            }

                            this.setState({parcel, options, disabledOptions, parcelCarriers, prices, amounts, deliveryTimes, pickupDates, pickupPoints, infoMessages}, () => {
                                this.getOptions()
                            })
                        } else {
                            this.setState({parcel, options, disabledOptions, parcelCarriers, prices, amounts, deliveryTimes, pickupDates, pickupPoints, infoMessages})
                        }
                    } else {
                        this.setState({parcel, options, disabledOptions, parcelCarriers, prices, amounts, deliveryTimes, pickupDates, pickupPoints, infoMessages})
                    }
                }
            })
        }
    }

    validate() {
        const parcel = {...this.state.parcel}
        const {user, customers} = this.props

        const validation = {}
        let valid = true
        let focusId = ''

        let referenceRequired = user.isCustomer && user.settings.parcels.referenceRequired

        if (user.isReseller) {
            const customer = customers[parcel.customer]
            referenceRequired = customer && customer.settings.parcels.referenceRequiredReseller
        }

        if (parcel.carrier === 'DHL' && ['GB', 'IE'].includes(parcel.address.country) && !parcel.address.phone) {
            validation.phone = 'Telefoonnummer is verplicht voor DHL zendingen naar Engeland of Ierland'
            valid = false
        }

        if (parcel.carrier === 'DHL' && ['GB', 'IE'].includes(parcel.address.country) && !parcel.address.email) {
            validation.email = 'Emailadres is verplicht voor DHL zendingen naar Engeland of Ierland'
            valid = false
        }

        if (parcel.options.includes('Verificatiecode') && !parcel.address.email) {
            validation.email = 'Emailadres is verplicht voor zendingen met verificatiecode'
            valid = false
        }

        if (parcel.options.includes('Px') && !parcel.pxBarcode) {
            focusId = 'pxBarcode'
            validation.pxBarcode = true
            valid = false
        }

        if (referenceRequired && !parcel.reference) {
            focusId = 'reference'
            validation.reference = true
            valid = false
        }

        if (user.isReseller && !parcel.customer) {
            focusId = 'customer'
            validation.customer = true
            valid = false
        }

        if (!valid && focusId) {
            document.getElementById(focusId).focus()
        }

        const customsValid = !this.parcelCustoms || this.parcelCustoms.validate()
        const addressValid = this.parcelAddress.validate(validation)
        const pickupAddressValid = !parcel.pickupAddress || this.parcelPickupAddress.validate()

        this.setState({validation, error: !valid && 'Controleer de gemarkeerde invoervelden'})
        return valid && customsValid && addressValid && pickupAddressValid
    }

    onSubmit(event) {
        event.preventDefault()
        const parcel = {...this.state.parcel}

        // Prevent submitting by scanning barcode
        if (parcel.pxBarcode && document.getElementById('pxBarcode') === document.activeElement) {
            return
        }

        if (this.validate()) {
            if (!parcel.address.nr) {
                this.popup.open('Huisnummer ontbreekt', 'Weet je zeker dat je deze zending wilt aanmaken zonder huisnummer?', this.createParcel.bind(this, parcel))
            } else {
                this.createParcel(parcel)
            }
        }
    }

    createParcel(parcel) {
        const {createParcelMode} = this.state
        this.setState({loading: true, info: '', message: '', error: ''})

        if (createParcelMode === 'savePrint' || createParcelMode === 'savePrintAndNew') {
            if (parcel.carrier === 'PostNL-MSG' || parcel.carrier === 'DHL-MSG') {
                this.setState({info: 'Het ophalen van een label voor deze vervoerder kan een paar seconden duren.'})
            }
            if (parcel._id) {
                ParcelActions.edit(parcel, this.printLabel.bind(this))
            } else {
                ParcelActions.create(parcel, this.printLabel.bind(this))
            }
        } else {
            if (parcel._id) {
                ParcelActions.edit(parcel, this.response.bind(this))
            } else {
                ParcelActions.create(parcel, this.response.bind(this))
            }
        }

        if (parcel.address.save) {
            if (parcel.options.includes('Px')) {
                parcel.address.px = true
            }

            AddressActions.update([parcel.address])
        }
    }

    response(err) {
        const {callback, createParcelMode} = this.state

        if (err) {
            this.setState({loading: false, info: '', message: '', error: err})
        } else {
            typeof callback === 'function' && callback()
            if (createParcelMode === 'saveNew') {
                const {useOCR, rememberCustomer, customer} = this.state

                this.setState({...JSON.parse(JSON.stringify(this.initialState)), modalIsOpen: true, useOCR, rememberCustomer}, () => {
                    this.open()

                    if (rememberCustomer) {
                        this.onChangeCustomer({target: {value: customer._id}}) // Set customer again
                    }
                })
            } else {
                this.close()
            }
        }
    }

    printLabel(err, updatedParcel) {
        const {callback, createParcelMode, parcel} = this.state

        // Prevent creating a new parcel if printLabel returns an error
        if (!parcel._id) {
            this.setState({parcel: {...parcel, ...updatedParcel}})
        }

        if (err) {
            this.setState({loading: false, info: '', message: '', error: err})
        } else {
            typeof callback === 'function' && callback()

            const printCallback = () => {
                this.popup.close()

                ParcelActions.printLabels([updatedParcel._id], 0, (err, pdf, errors, warnings) => {
                    if (err || errors[0]) {
                        this.setState({loading: false, info: '', message: '', error: err || errors[0]})
                    } else {
                        if (warnings[0]) {
                            this.setState({loading: false, info: '', message: '', error: '', warning: warnings[0]})
                        }

                        if (pdf) {
                            this.props.pdfModal.open(pdf)
                        }

                        if (createParcelMode === 'savePrintAndNew') {
                            const {useOCR, rememberCustomer, customer} = this.state

                            this.setState({...JSON.parse(JSON.stringify(this.initialState)), modalIsOpen: true, useOCR, rememberCustomer}, () => {
                                this.open()

                                if (rememberCustomer) {
                                    this.onChangeCustomer({target: {value: customer._id}}) // Set customer again
                                }
                            })
                        } else if (!warnings[0]) {
                            this.close()
                        }
                    }
                })
            }

            const incorrectAddresses = parcel.address.postalCode && parcel.address.country === 'NL' && (!parcel.address.position || parcel.address.showWarning)

            if (incorrectAddresses) {
                this.popup.open('Foutieve adressen', undefined, () => {
                    printCallback()
                }, () => {
                    this.setState({loading: false, info: '', message: '', error: ''})
                })

                this.popup.setWarning('Deze zending heeft een onbekende combinatie van postcode/straatnaam + huisnummer. Wil je toch doorgaan met het printen van de label?')
            } else {
                printCallback()
            }
        }
    }

    render() {
        const {customer, parcel, parcelCarriers, prices, options, disabledOptions, amounts, deliveryTimes, pickupDates, pickupPoints, modalIsOpen, useOCR, ocrLoading, sizeOption, validation, rememberCustomer, createParcelMode, loading, info, message, error, warning} = this.state
        const {reseller, user, addressBook, customers, carriers} = this.props

        const pickAndShip = parcel.options.indexOf('Pick & Ship') > -1
        const pickAndReturn = parcel.options.indexOf('Pick & Return') > -1
        const hasOptionFields = pickAndShip || pickAndReturn || ['Verzekerd', 'Spoed levering', 'Afhaalpunt', 'Px'].some((option) => parcel.options.includes(option))

        return (
            <>
                <Modal show={modalIsOpen} onClose={this.close.bind(this)}>
                    {/* Next to the modal, inside it so it lies above the backdrop */}
                    {useOCR &&
                        <div style={{position: 'fixed', top: 20, right: 'calc(50% + 420px)'}}>
                            <OCR
                                onClose={() => this.setState({useOCR: false})}
                                onChange={({address}) => {
                                    if (!address) {
                                        this.setState({ocrLoading: false})
                                        return
                                    }

                                    const scannedAddress = {
                                        ...this.state.parcel.address,
                                        name: address.name,
                                        attention: address.attention,
                                        street: address.street,
                                        nr: address.nr,
                                        addition: address.addition,
                                        postalCode: address.postalCode,
                                        city: address.city
                                    }

                                    // the position belongs to the previous address
                                    if (!scannedAddress.overridePosition) {
                                        delete scannedAddress.position
                                    }

                                    this.onChangeAddress(scannedAddress)

                                    // The address block only looks up the postal code after the user typed it, so look up the scanned one here.
                                    // After the update, otherwise the address block cancels the lookup when it sees the new postal code.
                                    // Stay loading until the lookup is done, so the 'postcode not found' error doesn't flash in between
                                    const lookupId = this.ocrLookupId = (this.ocrLookupId || 0) + 1
                                    this.setState({}, async () => {
                                        await this.parcelAddress?.autocomplete(this.state.parcel.address)

                                        // a newer scan started in the meantime, that one ends the loading state
                                        if (lookupId === this.ocrLookupId) {
                                            this.setState({ocrLoading: false})
                                        }
                                    })
                                }}
                                onStartOCR={() => {
                                    this.ocrLookupId = (this.ocrLookupId || 0) + 1

                                    const parcel = {...this.state.parcel}
                                    parcel.address.name = ''
                                    parcel.address.attention = ''
                                    parcel.address.street = ''
                                    parcel.address.nr = ''
                                    parcel.address.addition = ''
                                    parcel.address.postalCode = ''
                                    parcel.address.city = ''

                                    this.onChangeAddress(parcel.address)
                                    this.setState({ocrLoading: true})
                                }}
                            />
                        </div>
                    }

                    <ModalHeader title={parcel._id ? 'Bewerk zending' : 'Nieuwe zending'} onClose={this.close.bind(this)}>
                        {user.permissions.parcelOCR &&
                            <IconButton
                                style={{marginRight: 8}}
                                icon='mdi mdi-text-recognition'
                                onClick={() => this.setState({useOCR: !useOCR})}
                            />
                        }
                    </ModalHeader>

                    <form onSubmit={this.onSubmit.bind(this)}>
                        <div>
                            {!user.isCustomer &&
                                <>
                                    <H6 style={{marginBottom: 12}}>Klant</H6>

                                    <FormStack style={{marginBottom: formSpacing.rowGap}}>
                                        <FormRow>
                                            <FormRow style={{flex: 1}}>
                                                <Select
                                                    id='customer'
                                                    openAfter={1}
                                                    label='Klant'
                                                    options={_.values(customers).filter((customer) => !customer.isArchived).map((customer) => ({value: customer._id, title: customer.name}))}
                                                    value={parcel.customer}
                                                    isInvalid={validation.customer}
                                                    onChange={this.onChangeCustomer.bind(this)}
                                                    ref={(ref) => this.selectCustomer = ref}
                                                />

                                                <Input
                                                    id='contact'
                                                    label='Contactpersoon'
                                                    suggestions={customer ? customer.contacts?.map((contact) => contact.name) : []}
                                                    suggestionFilter
                                                    value={parcel.contact}
                                                    onChange={this.onChangeContact.bind(this)}
                                                />
                                            </FormRow>

                                            {!reseller.isShop &&
                                                <Input
                                                    label='Emailadres'
                                                    value={parcel.emailTT}
                                                    onChange={this.onChangeValue.bind(this, 'emailTT')}
                                                />
                                            }
                                        </FormRow>

                                        {(useOCR || rememberCustomer) && (createParcelMode == 'saveNew' || createParcelMode == 'savePrintAndNew') &&
                                            <Check label='Onthoud klant' checked={rememberCustomer} onChange={(event) => this.setState({rememberCustomer: event.target.checked})} />
                                        }
                                    </FormStack>
                                </>
                            }

                            {pickAndShip &&
                                <>
                                    <H6 style={{marginBottom: 12, marginTop: 24}}>Ophaaladres</H6>
                                    <Address
                                        title='Ophaaladres'
                                        address={parcel.pickupAddress}
                                        onChange={this.onChangePickupAddress.bind(this)}
                                        addressBook={addressBook}
                                        email={true}
                                        phone={true}
                                        saveCheckbox={true}
                                        noCountry={true}
                                        ref={(ref) => this.parcelPickupAddress = ref}
                                    />
                                </>
                            }

                            {parcel.options.includes('Retour') ?
                                <H6 style={{marginBottom: 12, marginTop: 24}}>Afzender</H6> :
                                <H6 style={{marginBottom: 12, marginTop: 24}}>Adres</H6>
                            }

                            <Address
                                address={JSON.parse(JSON.stringify(parcel.address))}
                                onChange={this.onChangeAddress.bind(this)}
                                addressBook={addressBook}
                                state={true}
                                email={true}
                                phone={true}
                                businessCheckbox={true}
                                saveCheckbox={true}
                                switchNameAttention={useOCR}
                                loading={ocrLoading}
                                ref={(ref) => this.parcelAddress = ref}
                            />

                            {useOCR && !ocrLoading && parcel.address.country === 'NL' && parcel.address.postalCode && parcel.address.nr && !parcel.address.position &&
                                <Alert variant='error' style={{marginBottom: 6, marginTop: 16}}>Deze postcode, huisnummer combinatie is niet gevonden. Controleer of het adres klopt of voeg een toevoeging toe.</Alert>
                            }

                            <H6 style={{marginBottom: 12, marginTop: 24}}>Inhoud</H6>

                            <FormStack style={{marginBottom: formSpacing.rowGap}}>
                                <FormRow>
                                    <FormRow style={{flex: 1}}>
                                        {user.isCustomer && user.settings.parcels?.sizes?.length > 0 && (
                                            <Select
                                                label='Standaardformaten'
                                                value={sizeOption}
                                                onChange={this.onChangeParcelSize.bind(this)}
                                            >
                                                {user.settings.parcels.sizes.map((size, index) => (
                                                    <option key={index} value={index}>{size.name}</option>
                                                ))}
                                            </Select>
                                        )}
                                        <Input
                                            id='reference'
                                            label='Referentie'
                                            info='Het referentieveld gebruik je voor interne referenties. Bijvoorbeeld wie heeft de zending verstuurd of bij welk ordernummer hoort hij. De referentie komt ook terug in de factuurbijlage.'
                                            value={parcel.reference}
                                            isInvalid={validation.reference}
                                            onChange={this.onChangeValue.bind(this, 'reference')}
                                        />
                                    </FormRow>

                                    <Input
                                        label='Bezorginstructie'
                                        info='Het instructieveld is voor de koerier. Hierin kan een mogelijke extra bezorginstructie.'
                                        value={parcel.comment}
                                        onChange={this.onChangeValue.bind(this, 'comment')}
                                    />
                                </FormRow>

                                <FormRow>
                                    <MetricInput
                                        label='Gewicht'
                                        max={999999999}
                                        divisionFactor={1000}
                                        value={parcel.weight}
                                        onChange={this.onChangeWeight.bind(this)}
                                        append='kg'
                                    />

                                    <MetricInput
                                        label='Lengte'
                                        value={parcel.length || 0}
                                        divisionFactor={10}
                                        onChange={this.onChangeValue.bind(this, 'length')}
                                        append='cm'
                                    />

                                    <MetricInput
                                        label='Breedte'
                                        value={parcel.width || 0}
                                        divisionFactor={10}
                                        onChange={this.onChangeValue.bind(this, 'width')}
                                        append='cm'
                                    />

                                    <MetricInput
                                        label='Hoogte'
                                        value={parcel.height || 0}
                                        divisionFactor={10}
                                        onChange={this.onChangeValue.bind(this, 'height')}
                                        append='cm'
                                    />
                                </FormRow>

                                {!user.isCustomer && [...parcel.fees, {id: '', description: '', quantity: 1}].map((fee, index) => {
                                    return (
                                        <FormRow key={`fee${index}`}>
                                            <FormRow style={{flex: 1}}>
                                                <Select
                                                    allowEmpty
                                                    label='Toeslag'
                                                    value={fee.id}
                                                    onChange={this.onChangeFee.bind(this, 'id', index)}
                                                    options={(reseller.settings.parcels.fees || []).map((fee) => {
                                                        if (fee.id) {
                                                            return {title: fee.description, value: fee.id}
                                                        }
                                                    })}
                                                />

                                                {fee.id &&
                                                    <Input
                                                        noPlaceholder
                                                        style={{width: 100}}
                                                        label='Aantal'
                                                        value={fee.quantity}
                                                        onChange={this.onChangeFee.bind(this, 'quantity', index)}
                                                    />
                                                }
                                            </FormRow>
                                            <div style={{flex: 1}} />
                                        </FormRow>
                                    )
                                })}
                            </FormStack>

                            {(outsideEUCustoms(parcel.address) || (parcel.address.country === 'IE' && parcel.carrier === 'DHL')) &&
                                <>
                                    <H6 style={{marginBottom: 12, marginTop: 24}}>{t('customsInformation')}</H6>

                                    <ParcelCustoms
                                        parcel={parcel}
                                        onChange={this.onChangeParcelCustoms.bind(this)}
                                        ref={(ref) => this.parcelCustoms = ref}
                                    />
                                </>
                            }

                            {parcel.customer && parcel.address.postalCode && (parcel.address.country !== 'NL' || parcel.address.nr) && parcel.address.city && parcel.address.street &&
                                <>
                                    <H6 style={{marginBottom: 12, marginTop: 24}}>Verzendopties</H6>

                                    <ParcelOptions
                                        options={options}
                                        selected={parcel.options}
                                        disabledOptions={disabledOptions}
                                        onChange={this.onChangeOptions.bind(this)}
                                    />

                                    {hasOptionFields &&
                                        <FormStack style={{marginBottom: formSpacing.rowGap}}>
                                            {parcel.options.indexOf('Verzekerd') > -1 &&
                                                <Select
                                                    style={{maxWidth: 375}}
                                                    label='Verzekerd tot'
                                                    value={parcel.cover}
                                                    onChange={this.onChangeCover.bind(this)}
                                                >
                                                    {amounts.map((amount) => {
                                                        return <option key={amount} value={amount}>{`€ ${amount},-`}</option>
                                                    })}
                                                </Select>
                                            }

                                            {parcel.options.indexOf('Spoed levering') > -1 &&
                                                <Select
                                                    style={{maxWidth: 375}}
                                                    label='Leveren voor'
                                                    value={parcel.deliveryTime}
                                                    onChange={this.onChangeDeliveryTime.bind(this)}
                                                >
                                                    {deliveryTimes.map((deliveryTime) => {
                                                        return <option key={deliveryTime} value={deliveryTime}>{`${deliveryTime.indexOf('zaterdag') === -1 ? 'volgende werkdag ' : ''}${deliveryTime}`}</option>
                                                    })}
                                                </Select>
                                            }

                                            {(pickAndShip || pickAndReturn) &&
                                                <Select
                                                    style={{maxWidth: 375}}
                                                    label='Ophaaldatum'
                                                    value={parcel.pickupDate}
                                                    onChange={this.onChangeValue.bind(this, 'pickupDate')}
                                                >
                                                    {pickupDates.map((pickupDate) => {
                                                        return <option key={pickupDate} value={pickupDate}>{moment(pickupDate).format('DD-MM-YYYY')}</option>
                                                    })}
                                                </Select>
                                            }

                                            {parcel.options.indexOf('Afhaalpunt') > -1 &&
                                                <Select
                                                    label='Afhaalpunt'
                                                    value={parcel.pickupPoint ? parcel.pickupPoint.description : ''}
                                                    onChange={this.onChangePickupPoint.bind(this)}
                                                    options={pickupPoints.map((pickupPoint) => {
                                                        return {value: pickupPoint.description, title: `${pickupPoint.description}${parcelCarriers.length > 1 ? ` - ${user.isCustomer ? pickupPoint.carrierDisplayName || pickupPoint.carrier.replace('-onlineparcel', '') : pickupPoint.carrier}` : ''}`}
                                                    })}
                                                />
                                            }

                                            {parcel.options.indexOf('Px') > -1 &&
                                                <Input
                                                    id='pxBarcode'
                                                    style={{maxWidth: 375}}
                                                    label='Px barcode'
                                                    value={parcel.pxBarcode}
                                                    isInvalid={validation.pxBarcode}
                                                    onChange={(event) => this.onChangeValue('pxBarcode', event)}
                                                    ref={(ref) => this.pxBarcodeInput = ref}
                                                />
                                            }
                                        </FormStack>
                                    }

                                    <H6 style={{marginBottom: 12, marginTop: 24}}>Vervoerder</H6>

                                    {parcel.options.includes('Antwoordnummer') && parcel.options.length > 1 && parcel.carrier === 'PostNL' && (
                                        <Alert style={{marginBottom: 6}} variant='info'>Voor een zending naar een antwoordnummer met extra verzendopties worden kosten in rekening gebracht.</Alert>
                                    )}

                                    {parcel.options.includes('Antwoordnummer') && parcel.carrier !== 'PostNL' && (
                                        <Alert style={{marginBottom: 6}} variant='info'>Voor een zending naar een antwoordnummer met deze vervoerder worden kosten in rekening gebracht.</Alert>
                                    )}

                                    {parcelCarriers && parcelCarriers.length === 0 &&
                                        <Alert style={{marginBottom: 6}} variant='warning'>Er is geen vervoerder beschikbaar voor deze zending</Alert>
                                    }

                                    <div style={{width: '100%', overflowX: 'auto'}}>
                                        <CarrierSelector
                                            size={55}
                                            carriers={carriers}
                                            displayCarriers={parcelCarriers}
                                            value={parcel.carrier}
                                            options={parcel.options}
                                            prices={prices}
                                            onChange={this.onChangeValue.bind(this, 'carrier')}
                                            isCustomer={user.isCustomer}
                                        />
                                    </div>
                                </>
                            }
                        </div>

                        <br />
                        {info && <Alert style={{marginBottom: 6}} variant='info'>{info}</Alert>}
                        {message && <Alert style={{marginBottom: 6}} variant='success'>{message}</Alert>}
                        {warning && <Alert style={{marginBottom: 6}} variant='warning'>{warning}</Alert>}
                        {error && <Alert style={{marginBottom: 6}} variant='danger'>{error}</Alert>}

                        <ModalActions>
                            <SplitButton
                                type='submit'
                                loading={loading}
                                value={createParcelMode}
                                options={[
                                    {title: 'Opslaan', value: 'save'},
                                    {title: 'Opslaan + Print', value: 'savePrint'},
                                    {title: 'Opslaan + Nieuw', value: 'saveNew'},
                                    {title: 'Opslaan + Print + Nieuw', value: 'savePrintAndNew'}
                                ]}
                                onChange={(event) => {
                                    localStorage.createParcelMode = event.target.value
                                    this.setState({createParcelMode: event.target.value})
                                }}
                            >
                                {
                                    createParcelMode === 'saveNew' ?
                                        'Opslaan + Nieuw' :
                                        createParcelMode === 'savePrint' ?
                                            'Opslaan + Print' :
                                            createParcelMode === 'savePrintAndNew' ?
                                                'Opslaan + Print + Nieuw' :
                                                'Opslaan'
                                }
                            </SplitButton>
                        </ModalActions>
                    </form>

                    <Popup ref={(ref) => this.popup = ref} />
                </Modal>
            </>
        )
    }
}

export default EditParcelModal
